import React, { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Table, Input, Button } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import { useSelector, useDispatch } from 'react-redux';
import { updateProductQtyInCart, clearCartProducts, setOrderMetaData } from '../../redux/cart/cartSlice';
import { useNavigate } from 'react-router-dom';
import { createOrder, fetchBranches, getMerchantListing } from '../../utils/apiCalls';

const Cart = () => {
    const userType = localStorage.getItem("userType");

    const cartItems = useSelector(state => state.cart.cartItems);
    const cartTotals = useSelector(state => state.cart.cartTotals) || { subTotal: 0, vat: 0, total: 0 };
    const { branchId, orderType, merchantId: cartMerchantId } = useSelector(state => state.cart);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    // const handleQuantityChange = (lineIndex, actionType) => {
    //     dispatch(updateProductQtyInCart({ lineIndex, actionType }));
    // };
    // const handleQuantityChange = (lineIndex, actionType) => {
    // dispatch(updateProductQtyInCart({ lineIndex, actionType }));
    const handleQuantityChange = (cartItemId, actionType) => {
        dispatch(updateProductQtyInCart({ cartItemId, actionType }));
    };

    const calculateItemTotal = (item) => {
        const modifiersPrice = item.fullModifiers?.reduce((acc, mod) => acc + mod.price, 0) || 0;
        // return item.price * item.quantity + modifiersPrice;
        return (item.price + modifiersPrice) * item.quantity;
    };

    const handlePlaceOrder = async () => {

        const orderPayload = {
            products: cartItems.map(item => ({
                productID: item.id,
                quantity: item.quantity,
                note: item.note,
                modifiers: item?.fullModifiers?.map(modifier => ({
                    id: modifier.id,
                    quantity: 1, // Assuming quantity is always 1 for modifiers
                })),
            })),
            location_id: parseInt(branchId),
            orderType: orderType,
            // note: "", // You can add a general order note here if you have one
        };

        const result = await createOrder(orderPayload);

        if (result) {
            dispatch(clearCartProducts());
            // Optionally navigate to an order confirmation page
            navigate(`/Orders/Orders`);
        }
    };

    return (
        <Fragment>
            <Breadcrumb title="Shopping Cart" parent="Orders" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <div className="d-flex align-items-center">
                                    <Button color="light" size="sm" onClick={() => navigate(-1)} className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', padding: 0 }}>
                                        <ArrowLeft size={16} />
                                    </Button>
                                    <h5 className="mb-0 ms-3">Cart Details</h5>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {cartItems.length > 0 ? (
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Price</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cartItems.map((item) => (
                                                <tr key={item.cartItemId}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <img
                                                                src={item.image1 ? process.env.REACT_APP_URL + item.image1 : "https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/camera-512.png"}
                                                                alt={item.title}
                                                                style={{ width: '50px', height: '50px', borderRadius: '5px', marginRight: '15px' }}
                                                                onError={(e) => { e.target.src = "https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/camera-512.png"; }}
                                                            />
                                                            <div>
                                                                <strong>{item.title}</strong>
                                                                {item.note && (
                                                                    <div style={{ fontSize: '0.85em', color: '#555', fontStyle: 'italic' }}>
                                                                        Note: {item.note}
                                                                    </div>
                                                                )}
                                                                {item.fullModifiers && item.fullModifiers.length > 0 && (
                                                                    <div style={{ fontSize: '0.85em', color: '#555' }}>
                                                                        {item.fullModifiers.map(mod => (
                                                                            <div key={mod.id}>+ {mod.title} (SAR {mod.price.toFixed(2)})</div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>SAR {item.price.toFixed(2)}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                                                            {/* <Button size="lg" className="quantity-btn" onClick={() => handleQuantityChange(item.id, 'dec')}>-</Button> */}
                                                            <Button size="lg" className="quantity-btn" onClick={() => handleQuantityChange(item.cartItemId, 'dec')}>-</Button>
                                                            <Input
                                                                type="text"
                                                                value={item.quantity}
                                                                readOnly
                                                                style={{ width: '40px', textAlign: 'center' }}
                                                            />
                                                            {/* <Button size="lg" className="quantity-btn" onClick={() => handleQuantityChange(item.id, 'inc')}>+</Button> */}
                                                            <Button size="lg" className="quantity-btn" onClick={() => handleQuantityChange(item.cartItemId, 'inc')}>+</Button>
                                                        </div>
                                                    </td>
                                                    <td>SAR {calculateItemTotal(item).toFixed(2)}</td>
                                                    {/* <td>SAR {cartTotals.total?.toFixed(2)}</td> */}
                                                    <td>
                                                        {/* <Button color="danger" size="sm" onClick={() => handleQuantityChange(item.id, 'delete')}> */}
                                                        <Button color="danger" size="sm" onClick={() => handleQuantityChange(item.cartItemId, 'delete')}>
                                                            Remove
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div className="text-center">
                                        <h4>Your cart is empty.</h4>
                                        <Link to="/orders/create-order">
                                            <Button color="primary">Start Shopping</Button>
                                        </Link>
                                    </div>
                                )}
                            </CardBody>
                            {cartItems.length > 0 && (
                                <CardBody className="border-top">
                                    <Row className="justify-content-end">
                                        <Col md="4" className="text-end">
                                            <h6>Sub-Total: SAR {cartTotals.subTotal.toFixed(2)}</h6>
                                            <h6>VAT (15%): SAR {cartTotals.vat.toFixed(2)}</h6>
                                            <hr />
                                            <h4>Total: SAR {cartTotals.total?.toFixed(2)}</h4>
                                            <Button color="primary" block onClick={handlePlaceOrder} className="mt-3">
                                                Place Order
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default Cart;
